export function isSpecialTenant(hotelCode) {
  const vipFacilities = process.env.VIP_FACILITIES?.split(',') || []
  const isVIP = vipFacilities.includes(hotelCode)
  const pagespeedFacilities = process.env.PAGESPEED_FACILITIES?.split(',') || []
  const isPagespeedTenant = pagespeedFacilities.includes(hotelCode)
  const vue3Facilities = process.env.VUE3_FACILITIES?.split(',') || []
  const isVue3Tenant = vue3Facilities.includes(hotelCode)

  return isVue3Tenant || isVIP || isPagespeedTenant
}
